function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        position: relative;\n        width: ",
        ";\n        display: inline-block;\n        border: 1px solid ",
        ";\n        padding: 0.375rem 2rem 0.375rem 0.5rem;\n        font-size: 1em;\n        line-height: calc(1em - 2px);\n        appearance: none;\n        margin-top: 0.5rem;\n        cursor: pointer;\n        font-family: inherit;\n        transition: 0.2s ease-in-out box-shadow, 0.2s ease-in-out border;\n\n        background-color: #ffffff;\n        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDUwIDUwIiBoZWlnaHQ9IjUwcHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MCA1MCIgd2lkdGg9IjUwcHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iNTAiIHdpZHRoPSI1MCIvPjxwb2x5Z29uIHBvaW50cz0iNDcuMjUsMTUgNDUuMTY0LDEyLjkxNCAyNSwzMy4wNzggNC44MzYsMTIuOTE0IDIuNzUsMTUgMjUsMzcuMjUgIi8+PC9zdmc+'),\n          linear-gradient(to bottom, #ffffff 0%, #ffffff 100%);\n        background-repeat: no-repeat, repeat;\n        background-position: right 0.7em top 50%, 0 0;\n        background-size: 0.65em auto, 100%;\n\n        &::ms-expand {\n          display: none;\n        }\n\n        & > option {\n          font-weight: normal;\n        }\n\n        &:focus {\n          outline: 0;\n          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n          border-color: rgba(0, 123, 255, 0.25);\n        }\n\n        &:-moz-focusring {\n          color: transparent;\n          text-shadow: 0 0 0 ",
        ";\n        }\n\n        & > option:focus {\n          outline: 0;\n          border: none;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-flex;\n        width: 100%;\n        ",
        "\n        padding: ",
        " 0.75rem;\n        background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 17.71%),\n          rgba(213, 221, 230, 0.16);\n        border: 1px solid #d5dde6;\n        border-radius: 4px;\n        color: ",
        ";\n        font-size: 1em;\n        line-height: 1em;\n\n        & svg {\n          color: ",
        ";\n        }\n\n        &:focus {\n          box-shadow: none;\n          border-color: ",
        ";\n          outline: 0;\n        }\n\n        &:disabled {\n          background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(255, 255, 255, 0) 17.71%),\n            rgba(213, 221, 230, 0.56);\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        background: #ffffff;\n        border: 0.75px solid ",
        ";\n        border-radius: 7px;\n        padding: ",
        " 0.75rem;\n        resize: ",
        ";\n        color: ",
        ";\n        line-height: 1em;\n        height: 100px;\n        font-size: 1em;\n        width: 100%;\n        transition: 0.2s ease-in-out box-shadow, 0.2s ease-in-out border;\n\n        &:focus {\n          outline: none;\n          box-shadow: 0px 0px 10px rgba(69, 82, 96, 0.1);\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        background-color: ",
        ";\n        border: ",
        ";\n        color: ",
        ";\n        border-radius: 4px;\n        line-height: 2.375rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        font-weight: 500;\n        display: inline-flex;\n        align-items: center;\n        text-align: center;\n        letter-spacing: 1px;\n        text-transform: uppercase;\n        position: relative;\n        padding: 0 1rem;\n        white-space: nowrap;\n        background-position: center;\n        transition: background 0.6s;\n        outline: none;\n        ",
        "\n\n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n      \n        ",
        "\n\n        &:hover {\n          background: ",
        "\n            radial-gradient(\n              circle,\n              transparent 1%,\n              ",
        " 1%\n            )\n            center/15000%;\n          border-color: ",
        ";\n          color: #ffffff;\n\n          & a {\n            color: #ffffff;\n          }\n        }\n\n        &:active {\n          background-color: ",
        ";\n          background-size: 100%;\n          transition: background 0s;\n        }\n\n        &[disabled] {\n          opacity: 0.5;\n          cursor: not-allowed;\n          filter: none;\n        }\n\n        svg {\n          margin-right: 5px;\n          display: inline-block;\n\n          ",
        ";\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      position: relative;\n      width: 100%;\n      height: 100%;\n      flex: 1 0 auto;\n      margin-top: ",
        ";\n      z-index: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: block;\n      position: relative;\n      padding: 0;\n      ",
        "\n      max-width: ",
        ";\n      ",
        "\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      display: inline-block;\n      position: relative;\n      padding: 0;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        width: 100%;\n        max-width: ",
        ";\n        ",
        "\n        padding: 0 15px;\n        background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 17.71%),\n          rgba(213, 221, 230, 0.16);\n        border: 1px solid #d5dde6;\n        border-radius: 4px;\n        color: ",
        ";\n\n        & svg {\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n        width: 100%;\n        padding: ",
        " 0;\n        background: none;\n        border: none;\n\n        &:focus {\n          box-shadow: none;\n          border-color: transparent;\n          outline: 0;\n        }\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n        margin-right: 15px;\n        font-size: 18px;\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      align-items: center;\n      height: 70px;\n      padding: 0 40px;\n      position: sticky;\n      top: -1px;\n      transition: 0.2s ease-out;\n      background: #ffffff;\n      border-bottom: 1px solid #d3d7dc;\n      z-index: 2;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n        align-items: center;\n        padding: 15px 40px;\n        margin-bottom: 50px;\n        border-bottom: 1px solid #d3d7dc;\n\n        & .breadcrumbs-child {\n          color: ",
        ";\n          cursor: pointer;\n        }\n      "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-flex;\n        padding: 0 7px;\n\n        &:before {\n          content: '/';\n        }\n      "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "linear-gradient(90deg, ",
        ", #09f)"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n        height: ",
        ";\n        position: ",
        ";\n        background-color: ",
        ";\n        overflow: hidden;\n        padding: 1rem 0;\n        width: 100%;\n        border-bottom: 1px solid #ccc;\n        z-index: 10;\n        display: flex;\n      "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n        align-items: center;\n      "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n        width: auto;\n        height: 100%;\n      "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n        height: 100%;\n        flex: 1 1 auto;\n      "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n        flex: 0 0 auto;\n      "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      font-weight: 20px;\n      font-size: 600;\n      color: ",
        ";\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n        position: relative;\n      "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n        position: absolute;\n        min-width: 100%;\n        z-index: 10;\n        margin-top: 3px;\n        background: #ffffff;\n        border: 1px solid #eeeeee;\n        box-shadow: 1px 4px 8px rgba(69, 82, 96, 0.28);\n        border-radius: 6px;\n\n        button,\n        a {\n          margin: -10px;\n          text-align: left;\n          color: ",
        ";\n          background-color: ",
        ";\n          transition: none;\n\n          &:hover {\n            background: transparent;\n            color: ",
        ";\n          }\n\n          &:disabled {\n            color: #3333;\n          }\n        }\n\n        h3 {\n          display: flex;\n          align-items: center;\n          letter-spacing: 0.05em;\n          text-transform: uppercase;\n          padding: 15px 10px 12px 17.5px;\n          color: #a0a9b4;\n        }\n\n        li {\n          display: flex;\n          align-items: center;\n          padding: 10px 10px 10px 17.5px;\n          cursor: pointer;\n\n          &:hover {\n            background-color: rgba(",
        ", 0.16);\n          }\n        }\n\n        svg {\n          margin-right: 10px;\n        }\n      "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n        width: 100%;\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n        font-weight: bold;\n        padding: 0;\n        border: 1px solid ",
        ";\n        background-color: ",
        ";\n\n        ",
        ";\n\n        ",
        "\n\n        .overflow-wrapper {\n          overflow: hidden;\n          font-weight: inherit;\n        }\n        .sorting-wrapper {\n          display: block;\n          position: relative;\n          padding: 1rem;\n          font-weight: inherit;\n\n          svg {\n            position: absolute;\n            top: 50%;\n            right: 0;\n            transform: translateY(-50%);\n          }\n        }\n      "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n        padding: 1rem;\n        border: 1px solid ",
        ";\n        background-color: #ffffff;\n        ",
        ";\n      "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n        text-align: center;\n      "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n        margin-right: 0.3rem;\n        padding: 10px;\n        vertical-align: middle;\n      "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "2px solid ",
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "2px solid ",
        ""
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n        padding-top: 0.5rem;\n      "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-flex;\n        align-items: center;\n        margin-bottom: 0.5rem;\n        margin-right: 0.5rem;\n      "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-block;\n        ",
        "\n      "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 1;\n      "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-block;\n        position: relative;\n        width: 1rem;\n        height: 1rem;\n        margin-right: 0.5rem;\n        border: ",
        ";\n        vertical-align: top;\n        flex: 0 0 auto;\n\n        input:disabled ~ & {\n          border: ",
        ";\n        }\n\n        input:checked ~ &:after {\n          content: '';\n          background-color: ",
        ";\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: 50%;\n          height: 50%;\n        }\n\n        input:disabled ~ &:after {\n          background-color: ",
        ";\n        }\n      "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n        padding-top: 0.5rem;\n      "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-block;\n        margin-bottom: 0.5rem;\n        margin-right: 0.5rem;\n      "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-block;\n        ",
        "\n      "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n        position: absolute;\n        opacity: 0;\n      "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n        display: inline-block;\n        position: relative;\n        width: 1rem;\n        height: 1rem;\n        border-radius: 50%;\n        margin-right: 0.5rem;\n        border: ",
        ";\n        vertical-align: top;\n\n        input:checked ~ &:after {\n          content: '';\n          background-color: ",
        ";\n          border-radius: 50%;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          width: 50%;\n          height: 50%;\n        }\n      "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n              ",
        "\n            "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n          position: relative;\n          height: 100%;\n        "
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n          border: 1px solid\n            ",
        ";\n          position: relative;\n          display: flex;\n          flex-direction: column;\n          background-color: ",
        ";\n          box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.025);\n          border-radius: ",
        ";\n          height: 100%;\n          word-wrap: break-word;\n          transition: 0.3s ease-in box-shadow, 0.3s ease-out background-color;\n          ",
        "\n          ",
        "\n          ",
        "\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n          position: relative;\n          width: 100%;\n          background-color: ",
        ";\n          text-overflow: ellipsis;\n          flex: 0 1 auto;\n          padding: 1.5rem 1.5rem 1rem 1.5rem;\n          ",
        "\n          ",
        "\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n          flex: 1 0 auto;\n          width: 100%;\n          font-size: 0.9em;\n          line-height: 1.3;\n          font-weight: 300;\n          word-wrap: break-word;\n          white-space: normal;\n          z-index: 2;\n          position: relative;\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n          align-self: flex-end;\n          ",
        "\n          width: 100%;\n          text-align: inherit;\n        "
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n          position: absolute;\n          right: -9px;\n          top: -9px;\n          border-radius: 50%;\n          background: #fff;\n          z-index: 1;\n        "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        ";\n\n        .categories__option {\n          padding: 15px 12px;\n          cursor: pointer;\n        }\n\n        .categories__control,\n        .categories__control:hover,\n        .categories__control--is-focused {\n          border-color: ",
        ";\n          border-width: 1px;\n          box-shadow: none;\n        }\n      "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n\n      .react-date-picker__wrapper {\n        border: 1px solid ",
        ";\n        padding: ",
        " 0.75rem;\n        color: ",
        ";\n        width: 100%;\n      }\n\n      .react-calendar {\n        border-radius: 5px;\n        border-color: #dcdcdc;\n\n        button {\n          padding: 16px 0;\n          border-radius: 50%;\n          font-size: 12px;\n        }\n      }\n\n      button abbr {\n        border-bottom: none;\n      }\n\n      abbr {\n        border-bottom-style: dashed;\n      }\n\n      .react-calendar__tile--active {\n        background-color: ",
        ";\n      }\n\n      .react-calendar__navigation {\n        border-bottom: 1px solid #dcdcdc;\n\n        button {\n          border-radius: 0;\n          padding: 10px;\n          font-size: 14px;\n        }\n      }\n\n      button.react-calendar__year-view__months__month,\n      button.react-calendar__decade-view__years__year,\n      button.react-calendar__century-view__decades__decade {\n        border-radius: 0;\n      }\n\n      .react-calendar__month-view__weekdays__weekday {\n        padding: 10px;\n      }\n\n      .react-date-picker__inputGroup {\n        min-width: calc(100% - 30px);\n      }\n\n      input {\n        margin-top: 0;\n      }\n\n      button {\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        border: none;\n      }\n\n      input,\n      .react-date-picker__wrapper,\n      .react-date-picker__inputGroup {\n        font-size: 1em;\n        line-height: 1em;\n        color: ",
        ";\n        font-weight: 400;\n      }\n\n      .react-date-picker__calendar--open {\n        z-index: 10;\n      }\n\n      &.no-value {\n        .react-date-picker__inputGroup,\n        .react-date-picker__button {\n          opacity: 0.7;\n        }\n      }\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n      position: relative;\n      width: ",
        ";\n      overflow: hidden;\n      min-height: ",
        "rem;\n\n      &:after {\n        content: '';\n        position: absolute;\n        width: ",
        "rem;\n        height: ",
        "rem;\n        border-radius: 50%;\n        border: ",
        "rem dashed ",
        ";\n        top: 50%;\n        left: 50%;\n        animation: ",
        " 1.5s linear infinite;\n      }\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n        width: 100%;\n        height: 5rem;\n        flex: 0 1 auto;\n        align-self: flex-end;\n        position: relative;\n        bottom: 0;\n        padding: 1rem 0;\n      "
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n        max-width: 30rem;\n        width: 100%;\n        overflow: hidden;\n        margin: 0 auto;\n        text-align: center;\n        ",
        "\n      "
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n        opacity: 0.4;\n        cursor: pointer;\n        font-style: italic;\n        white-space: nowrap;\n\n        & > svg {\n          transition: 0.2s linear transform;\n        }\n\n        &:hover > svg {\n          transform: translateX(-0.4rem);\n        }\n      "
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            gap: 0.5em;\n          "
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n            color: #5c6673;\n            cursor: auto;\n            font-size: 0.7em;\n          "
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n            font-weight: bold;\n            font-size: 1.4em;\n          "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n        table-layout: fixed;\n        width: ",
        "px;\n\n        td,\n        th {\n          &:nth-child(1) {\n            width: 150px;\n            min-width: 150px;\n          }\n          &:nth-child(2) {\n            width: 100px;\n            min-width: 100px;\n            background: #f8f8fa;\n          }\n\n          ",
        "\n        }\n      "
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n        .active-view {\n          animation: ",
        " 1s forwards;\n        }\n\n        .hidden-view {\n          display: none;\n        }\n      "
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        li {\n          text-align: center;\n          flex: 1;\n          padding: 15px;\n          transition: 300ms all;\n          color: ",
        ";\n          border: 1px solid ",
        ";\n          font-weight: 500;\n          cursor: pointer;\n          background-color: #fff;\n          flex: 5;\n        }\n\n        li:first-child {\n          border-right: 1px solid ",
        ";\n        }\n\n        .active {\n          background-color: ",
        ";\n          color: #fff;\n          transition: 300ms all;\n        }\n\n        li:hover:not(.active):not(.between-label) {\n          opacity: 0.7;\n        }\n\n        li.between-label {\n          flex: 1;\n          cursor: default;\n          border-left: none;\n          border-right: none;\n        }\n      "
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n      from {\n        transform: translate(-50%, -50%) rotate(0deg);\n      }\n    \n      to {\n        transform: translate(-50%, -50%) rotate(360deg);\n      }\n    "
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n      10%, 90% {\n        transform: translate3d(-1px, 0, 0);\n      }\n    \n      20%, 80% {\n        transform: translate3d(2px, 0, 0);\n      }\n    \n      30%, 50%, 70% {\n        transform: translate3d(-4px, 0, 0);\n      }\n    \n      40%, 60% {\n        transform: translate3d(4px, 0, 0);\n      }\n    "
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n      0% {\n        opacity: 0;\n        transform: translateY(100px);\n      }\n\n      100% {\n        opacity: 1;\n      }\n    "
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
import { css, keyframes } from "styled-components";
import mergeDeep from "../utils/merge-deep";
export var standardTheme = {
    palette: {
        primary: "#048CBA",
        secondary: "#c7e2ed",
        primaryText: "#455260",
        secondaryText: "#FAFAFA",
        muted: "#CED4DA",
        background: "#F8F8FA",
        error: "#FF3B30",
        success: "#5DD2BC",
        warning: "#FF9500",
        neutral: "#B2BEC3",
        lighterBlue: "#A4E8FF",
        lighterBlueRgb: "164,232,255",
        lightBlue: "#05B5F0",
        midBlue: "#125166",
        darkBlue: "#013545",
        lighterGreen: "#CAF8A3",
        lightGreen: "#A8E066",
        midGreen: "#6ECC00",
        green: "#5BBB00",
        lighterGrey: "#D3D7DC",
        lightGrey: "#5C6673",
        grey: "#5C6673",
        midGrey: "#455260",
        darkGrey: "#263238"
    },
    brand: {
        name: "",
        tagline: "",
        logo: "",
        smallLogo: "",
        isBrandLogo: false
    },
    font: {
        family: "Rubik",
        size: "1em",
        lineHeight: "1.15",
        mediumFontSize: "1.5em"
    },
    components: {
        native: {
            select: css(_templateObject(), function(param) {
                var theme = param.theme, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
                var ref;
                return fullWidth ? "100%;" : (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.width;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }),
            input: css(_templateObject1(), function(param) {
                var fullWidth = param.fullWidth;
                return fullWidth && "max-width: 100%;";
            }, function(param) {
                var theme = param.theme;
                var ref;
                return (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.padding;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.lightBlue;
            }),
            textArea: css(_templateObject2(), function(param) {
                var theme = param.theme;
                return theme.palette.lighterGrey;
            }, function(param) {
                var large = param.large;
                return large ? "0.64rem" : "0.375rem";
            }, function(param) {
                var noResize = param.noResize;
                return noResize ? "none" : "vertical";
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }),
            button: css(_templateObject3(), function(param) {
                var theme = param.theme, _outline = param.outline, outline = _outline === void 0 ? false : _outline, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return outline ? "transparent" : primary ? theme.palette.primary : theme.palette.secondary;
            }, function(param) {
                var theme = param.theme, _outline = param.outline, outline = _outline === void 0 ? false : _outline, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return outline ? "1px solid ".concat(primary ? theme.palette.primary : theme.palette.secondary) : "1px solid transparent";
            }, function(param) {
                var theme = param.theme, _outline = param.outline, outline = _outline === void 0 ? false : _outline, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return outline ? theme.palette.primary : primary ? "#ffffff" : theme.palette.primary;
            }, function(param) {
                var fullWidth = param.fullWidth;
                return fullWidth && "width: 100%;";
            }, function(param) {
                var large = param.large;
                return large && "\n          line-height: 3.25rem;\n          font-size: 1.125rem;\n        ";
            }, function(param) {
                var medium = param.medium;
                return medium && "\n          line-height: 2.875rem;\n          font-size: 1rem;\n        ";
            }, function(param) {
                var small = param.small;
                return small && "\n          line-height: 2rem;\n          font-size: 0.812rem;\n          border-radius: 3px;\n        ";
            }, function(param) {
                var success = param.success, theme = param.theme;
                return success && "\n          background-color: ".concat(theme.palette.success, ";\n        ");
            }, function(param) {
                var warning = param.warning, theme = param.theme;
                return warning && "\n          background-color: ".concat(theme.palette.warning, ";\n        ");
            }, function(param) {
                var error = param.error, theme = param.theme;
                return error && "\n          background-color: ".concat(theme.palette.error, ";\n        ");
            }, function(param) {
                var custom = param.custom, theme = param.theme;
                return custom && "\n          background-color: ".concat(theme.palette.custom, ";\n        ");
            }, function(param) {
                var customFilter = param.customFilter, theme = param.theme;
                return customFilter && "\n          filter: ".concat(theme.palette.customFilter, ";\n        ");
            }, function(param) {
                var theme = param.theme, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return primary ? theme.palette.lightBlue : theme.palette.primary;
            }, function(param) {
                var theme = param.theme, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return primary ? theme.palette.lightBlue : theme.palette.primary;
            }, function(param) {
                var theme = param.theme, outline = param.outline, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return outline ? primary ? theme.palette.lightBlue : theme.palette.primary : "transparent";
            }, function(param) {
                var theme = param.theme, _primary = param.primary, primary = _primary === void 0 ? true : _primary;
                return primary ? theme.palette.lighterBlue : theme.palette.primary;
            }, function(param) {
                var asIcon = param.asIcon;
                return asIcon ? "margin-right: 0;" : "";
            })
        },
        text: {
            muted: {
                color: css(_templateObject4(), function(param) {
                    var theme = param.theme;
                    return theme.palette.muted;
                })
            }
        },
        content: css(_templateObject5(), function(param) {
            var theme = param.theme;
            return theme.components.navbar.position === "static" ? 0 : theme.components.navbar.height;
        }),
        inputWrapper: css(_templateObject6(), function(param) {
            var fullWidth = param.fullWidth;
            return fullWidth && " width: 100%;";
        }, function(param) {
            var theme = param.theme;
            var ref;
            return (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.width;
        }, function(param) {
            var fullWidth = param.fullWidth;
            return fullWidth && " max-width: 100%;";
        }),
        textAreaWrapper: css(_templateObject7(), function(param) {
            var _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
            return fullWidth ? "width: 100%;" : "";
        }),
        searchBox: {
            wrapper: css(_templateObject8(), function(param) {
                var theme = param.theme;
                var ref;
                return (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.width;
            }, function(param) {
                var fullWidth = param.fullWidth;
                return fullWidth && "max-width: 100%;";
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }),
            input: css(_templateObject9(), function(param) {
                var theme = param.theme;
                var ref;
                return (ref = theme.components.form) === null || ref === void 0 ? void 0 : ref.padding;
            }),
            icon: css(_templateObject10())
        },
        card: {
            borderColor: css(_templateObject11(), function(param) {
                var theme = param.theme;
                return theme.palette.lighterGrey;
            }),
            borderColorSelected: "#BBBBBB",
            borderColorHover: "#BBBBBB",
            backgroundColor: "#FFFFFF",
            hoverBackgroundColor: "#FCFCFC",
            headerColor: "transparent",
            borderRadius: "0.25rem",
            selectedIconColor: "#BBBBBB"
        },
        label: {
            fontSize: "1.1rem"
        },
        stickyHeader: css(_templateObject12()),
        breadcrumbs: {
            base: css(_templateObject13(), function(param) {
                var theme = param.theme;
                return theme.palette.primaryText;
            }),
            optionsBreaker: css(_templateObject14())
        },
        hero: {
            backgroundColor: css(_templateObject15(), function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }),
            backgroundImage: css(_templateObject16(), function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }),
            height: "24rem",
            marginBottom: "1rem",
            top: "35%",
            brandName: {
                brandNameHeight: "2.5em",
                brandNameFontWeight: "400"
            },
            tagline: {
                taglineHeight: "1.6em"
            },
            logo: {
                height: "200%"
            }
        },
        navbar: {
            backgroundColor: "#FFFFFF",
            height: "5.5rem",
            position: "static",
            container: css(_templateObject17(), function(param) {
                var theme = param.theme;
                return theme.components.navbar.height;
            }, function(param) {
                var theme = param.theme;
                return theme.components.navbar.position;
            }, function(param) {
                var theme = param.theme;
                return theme.components.navbar.backgroundColor;
            }),
            wrapper: css(_templateObject18()),
            img: css(_templateObject19()),
            imgContainer: css(_templateObject20()),
            menu: css(_templateObject21())
        },
        title: css(_templateObject22(), function(param) {
            var theme = param.theme;
            return theme.palette.primary;
        }),
        dropdown: {
            container: css(_templateObject23()),
            list: css(_templateObject24(), function(param) {
                var theme = param.theme;
                return theme.components.dropdown.color;
            }, function(param) {
                var theme = param.theme;
                return theme.components.dropdown.buttonsBackgroundColor;
            }, function(param) {
                var theme = param.theme;
                return theme.components.dropdown.color;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.lighterBlueRgb;
            }),
            color: "#333",
            border: "1px solid #ddd",
            borderRadius: "0",
            buttonsBackgroundColor: "#FFF",
            buttonsBackgroundColorHover: "#ddd"
        },
        decisionTree: {
            questions: {
                fontSize: "18px",
                finalQuestionFontWeight: "normal"
            },
            answers: {
                backgroundColor: css(_templateObject25(), function(param) {
                    var theme = param.theme;
                    return theme.palette.lighterGrey;
                }),
                border: "none",
                color: css(_templateObject26(), function(param) {
                    var theme = param.theme;
                    return theme.palette.primaryText;
                }),
                fontWeight: "normal",
                hoverBoxShadow: "0px 0px 3px rgba(0,0,0,0.2)",
                selectedAnswer: css(_templateObject27(), function(param) {
                    var theme = param.theme;
                    return theme.palette.lightGrey;
                }),
                selectedAnswerBorder: "none",
                selectedAnswerColor: "#ffffff",
                displaySelectedIcon: false,
                questionSummaryColor: css(_templateObject28(), function(param) {
                    var theme = param.theme;
                    return theme.palette.primary;
                }),
                answerSummaryColor: "#5a5a5a",
                width: "100%",
                helpText: {
                    color: "#626262"
                }
            },
            footer: {
                buttonBorderRadius: "0px",
                buttonPadding: "10px 20px"
            }
        },
        table: {
            base: css(_templateObject29(), function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }),
            th: css(_templateObject30(), function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }, function(param) {
                var textAlign = param.textAlign;
                return textAlign ? "text-align: ".concat(textAlign) : "";
            }, function(param) {
                var isSortable = param.isSortable;
                return isSortable ? "cursor: pointer;" : "";
            }),
            td: css(_templateObject31(), function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }, function(param) {
                var textAlign = param.textAlign;
                return textAlign ? "text-align: ".concat(textAlign) : "";
            }),
            emptyTd: css(_templateObject32())
        },
        pagination: {
            button: css(_templateObject33())
        },
        modal: {
            borderRadius: "0px",
            confirmation: {
                buttons: {
                    borderRadius: "0px",
                    padding: "0.2rem 1rem"
                }
            }
        },
        radio: {
            border: css(_templateObject34(), function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }),
            disabledBorder: css(_templateObject35(), function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }),
            checkedColor: css(_templateObject36(), function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }),
            disabledColor: css(_templateObject37(), function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            })
        },
        checkboxGroup: {
            container: css(_templateObject38()),
            label: css(_templateObject39()),
            checkbox: css(_templateObject40(), function(param) {
                var vertical = param.vertical;
                return vertical && "display: block;";
            }),
            hiddenInput: css(_templateObject41()),
            checkboxButton: css(_templateObject42(), function(param) {
                var theme = param.theme;
                return theme.components.radio.border;
            }, function(param) {
                var theme = param.theme;
                return theme.components.radio.disabledBorder;
            }, function(param) {
                var theme = param.theme;
                return theme.components.radio.checkedColor;
            }, function(param) {
                var theme = param.theme;
                return theme.components.radio.disabledColor;
            })
        },
        radioGroup: {
            container: css(_templateObject43()),
            label: css(_templateObject44()),
            radio: css(_templateObject45(), function(param) {
                var vertical = param.vertical;
                return vertical && "display: block;";
            }),
            hiddenInput: css(_templateObject46()),
            radioButton: css(_templateObject47(), function(param) {
                var theme = param.theme;
                return theme.components.radio.border;
            }, function(param) {
                var theme = param.theme;
                return theme.components.radio.checkedColor;
            })
        },
        tabs: {
            linksWrapper: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                padding: "1rem 0"
            },
            indicator: {
                width: "100%",
                height: "0.2rem",
                backgroundColor: function(param) {
                    var theme = param.theme;
                    return theme.palette.primary;
                },
                position: "relative"
            },
            disableIndicatorScalingAnimation: false
        },
        productDetails: {
            rows: {
                documents: {
                    tableHeaderBackground: "#dee2e6"
                }
            },
            headerRows: {
                borderRadius: "0",
                padding: "5px",
                colors: [
                    {
                        backgroundColor: css(_templateObject48(), function(param) {
                            var theme = param.theme;
                            return theme.palette.primary;
                        }),
                        filter: "brightness(1.01)",
                        color: "#fff"
                    }, 
                ]
            },
            header: {
                sticky: false,
                divider: true,
                backdrop: false
            },
            cart: {
                sticky: false,
                margin: "0",
                maxHeight: null
            },
            backButton: {}
        },
        productList: {
            toolbar: {
                filtersDropdown: {
                    buttonComponent: null
                }
            },
            spring: "noWobble",
            centered: {
                start: "xs"
            },
            card: {
                wrapper: css(_templateObject49()),
                container: css(_templateObject50(), function(props) {
                    return props.selected ? props.theme.components.card.borderColorSelected : props.theme.components.card.borderColor;
                }, function(param) {
                    var theme = param.theme;
                    return theme.components.card.backgroundColor;
                }, function(param) {
                    var theme = param.theme;
                    return theme.components.card.borderRadius;
                }, function(param) {
                    var onClick = param.onClick, theme = param.theme, selected = param.selected;
                    return onClick && "\n            &:hover {\n              background-color: ".concat(theme.components.card.hoverBackgroundColor, ";\n              border-color: ").concat(selected ? theme.components.card.borderColorSelected : theme.components.card.borderColorHover, ";\n              cursor: pointer;\n              box-shadow: 0 0.5rem 2rem rgba(0,0,0,0.1) ;\n            }\n          ");
                }, function(param) {
                    var _center = param.center, center = _center === void 0 ? false : _center;
                    return center && "\n            justify-content: center;\n            align-items: stretch;\n            text-align: center;\n          ";
                }, function(param) {
                    var zDepth = param.zDepth;
                    return zDepth && "\n            box-shadow: 0 0 ".concat(zDepth * 2, "px rgba(0,0,0,0.10), -").concat(zDepth * 2, "px ").concat(zDepth * 2, "px ").concat(zDepth * 3, "px rgba(0,0,0,0.20);\n          ");
                }, function(param) {
                    var noBorder = param.noBorder;
                    return noBorder && "\n            border: none;\n            border-radius: none;\n          ";
                }, function(param) {
                    var verticalScroll = param.verticalScroll;
                    return verticalScroll && "\n            overflow-y: auto;\n          ";
                }),
                header: css(_templateObject51(), function(param) {
                    var theme = param.theme;
                    return theme.components.card.headerColor;
                }, function(param) {
                    var flex = param.flex;
                    return flex && "\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            align-items: center;\n          ";
                }, function(param) {
                    var divider = param.divider;
                    return divider && "border-bottom: 1px solid #ddd;";
                }, function(param) {
                    var sticky = param.sticky;
                    return sticky && "\n            position: sticky;\n            top: 0;\n            z-index: 3;\n            background-color: #FFFFFF;\n          ";
                }, function(param) {
                    var backdrop = param.backdrop;
                    return backdrop && "background-color: #FBF9F9;";
                }),
                body: css(_templateObject52(), function(param) {
                    var unpadded = param.unpadded;
                    return !unpadded && "padding: 1rem 1.5rem 2.5rem 1.5rem;";
                }, function(param) {
                    var _align = param.align, align = _align === void 0 ? "left" : _align;
                    return "text-align: ".concat(align, ";");
                }, function(param) {
                    var verticalScroll = param.verticalScroll;
                    return verticalScroll && "\n            flex: 0 1 auto;\n            overflow-y: auto;\n          ";
                }),
                footer: css(_templateObject53(), function(param) {
                    var unpadded = param.unpadded;
                    return !unpadded && "padding: 1rem 1.5rem 1.5rem 1.5rem;";
                }),
                selectedCardIcon: css(_templateObject54())
            }
        },
        form: {
            width: "300px",
            padding: css(_templateObject55(), function(param) {
                var large = param.large;
                return large ? "0.837rem" : "0.587rem";
            })
        },
        dropdownInput: {
            container: css(_templateObject56(), function(param) {
                var fullWidth = param.fullWidth;
                return fullWidth ? "100%" : "300px";
            }, function(param) {
                var theme = param.theme;
                return theme.palette.muted;
            }),
            borderRadius: "0",
            selectedColor: "#0984E3"
        },
        reactDatePicker: css(_templateObject57(), function(param) {
            var theme = param.theme;
            return theme.palette.muted;
        }, function(param) {
            var large = param.large;
            return large ? "0.64rem" : "0.375rem";
        }, function(param) {
            var theme = param.theme;
            return theme.palette.primaryText;
        }, function(param) {
            var theme = param.theme;
            return theme.palette.primary;
        }, function(param) {
            var theme = param.theme;
            return theme.palette.primaryText;
        }),
        textArea: {
            rows: 3
        },
        progress: css(_templateObject58(), function(param) {
            var _width = param.width, width = _width === void 0 ? "100%" : _width;
            return width;
        }, function(param) {
            var _size = param.size, size = _size === void 0 ? 6 : _size;
            return size;
        }, function(param) {
            var _size = param.size, size = _size === void 0 ? 6 : _size;
            return size;
        }, function(param) {
            var _size = param.size, size = _size === void 0 ? 6 : _size;
            return size;
        }, function(param) {
            var _size = param.size, size = _size === void 0 ? 6 : _size;
            return Number(size) / 12;
        }, function(param) {
            var theme = param.theme;
            return theme.palette.primary;
        }, function(param) {
            var theme = param.theme;
            return theme.animations.rotate;
        }),
        footer: {
            base: css(_templateObject59()),
            innerContainer: css(_templateObject60(), function(param) {
                var theme = param.theme;
                return "\n            color: ".concat(theme.palette.muted, ";\n          hr {\n            border-color: ").concat(theme.palette.muted, ";\n            opacity: 0.5;\n          }\n        ");
            })
        },
        backButton: {
            container: css(_templateObject61())
        },
        phases: {
            itemGroup: {
                valueColumn: {
                    container: css(_templateObject62()),
                    label: css(_templateObject63()),
                    div: css(_templateObject64())
                }
            },
            leftTable: css(_templateObject65(), function(param) {
                var customComponents = param.customComponents;
                return (customComponents === null || customComponents === void 0 ? void 0 : customComponents.length) ? customComponents === null || customComponents === void 0 ? void 0 : customComponents.reduce(function(total, dropdown) {
                    return dropdown.width + total;
                }, 0) : 250;
            }, function(param) {
                var customComponents = param.customComponents;
                return customComponents ? customComponents.map(function(comp, index) {
                    return "\n          &:nth-child(".concat(index + 3, ") {\n            width: ").concat(comp.width, "px;\n            min-width: ").concat(comp.width, "px;\n            background: ").concat(comp.background || "transparent", ";\n          }\n        ");
                }) : null;
            })
        },
        splitView: {
            container: css(_templateObject66(), function(param) {
                var theme = param.theme;
                return theme.animations.fadeIn;
            }),
            switcher: css(_templateObject67(), function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }, function(param) {
                var theme = param.theme;
                return theme.palette.primary;
            }),
            mainView: css(_templateObject68()),
            secondaryView: css(_templateObject69())
        }
    },
    animations: {
        rotate: keyframes(_templateObject70()),
        shakeAnimation: keyframes(_templateObject71()),
        fadeIn: keyframes(_templateObject72())
    }
};
export var extendTheme = function(override) {
    return mergeDeep(standardTheme, override);
};
